var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "dashpending-wrap"
  }, [_vm.title ? _c('div', {
    staticClass: "dashpending-card-title"
  }, [_c('h2', [_vm._v("Pending Items")])]) : _vm._e(), _c('div', {
    staticClass: "flex-container-wrap"
  }, [!_vm.isEnrollPrime ? [_vm.isRestrictDownline ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "rep-reg.svg",
      "title": "Edit Enrollments within 24hrs",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.enrollments_24hrs_count || 0,
      "routeLink": {
        name: 'Enrollments24hr'
      }
    }
  })], 1) : _vm._e()] : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "signature.svg",
      "title": "Pending Customer Signature",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_document_count || 0,
      "routeLink": {
        name: 'PendingSignatureList'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "reps.svg",
      "title": "Broker Registration in Progress",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_rep_administrator_count || 0,
      "routeLink": {
        name: 'PendingRepRegistrationList'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "old.svg",
      "title": "Members turning 65+",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_member_turing_65_count || 0,
      "routeLink": {
        name: 'PendingMember65List'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "child.svg",
      "title": "Dependents turning 26",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_child_aging_off_count || 0,
      "routeLink": {
        name: 'PendingDependentsChildList'
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "enrollments.svg",
      "title": "Pending Enrollment in Process",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_enrollment_count || 0,
      "routeLink": {
        name: 'PendingEnrollmentList'
      }
    }
  })], 1), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "group.svg",
      "title": "Group Registration in progress",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_group_registration_count || 0,
      "routeLink": {
        name: 'PendingGroupRegistrationList'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "rep-reg.svg",
      "title": "Downline Pending Activation",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_downline_count || 0,
      "routeLink": {
        name: 'PendingDowlineRepList'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "reps.svg",
      "title": "Pending Underwriting List",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_underwriting_count || 0,
      "routeLink": {
        name: 'PendingUnderwritingRepList'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "spouse.svg",
      "title": "Deps turning 65 ",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_spouse_aging_off_count || 0,
      "routeLink": {
        name: 'PendingDependentsSpouseList'
      }
    }
  })], 1) : _vm._e(), _vm.repInfo.enablePlanSwithOption && _vm.displayCards ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "signature.svg",
      "title": "Pending Renewals",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.renewal_count || 0,
      "routeLink": {
        name: 'PendingRenewals'
      }
    }
  })], 1) : _vm._e(), _vm.repInfo.enablePlanSwithOption && _vm.displayCards && _vm.planSwitchActive ? _c('div', {
    staticClass: "flex-item"
  }) : _vm._e(), _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "checkmark.svg",
      "title": "Pending Group Submission",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.pending_group_submission_count || 0,
      "routeLink": {
        name: 'PendingSubmission'
      }
    }
  })], 1), _vm.displayCards && _vm.isL713Rep ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "old.svg",
      "title": "Active Members (65 or Older)-L713 Medical Plan",
      "loading": _vm.isStatsLoading,
      "value": _vm.pendingStats.active_members_65_l713 || 0,
      "routeLink": {
        name: 'l713ActiveMembers'
      }
    }
  })], 1) : _vm._e(), _vm.displayCards && _vm.pendingStats.pending_group_renewals ? _c('div', {
    staticClass: "flex-item"
  }, [_c('pending-block', {
    staticClass: "mb-3 h-100",
    attrs: {
      "image-name": "group.svg",
      "title": "Group Renewals - (Upcoming 30/60/90 days)",
      "value": _vm.pendingStats.pending_group_renewals,
      "loading": _vm.isStatsLoading,
      "routeLink": {
        name: 'pendingGroupRenewals'
      }
    }
  })], 1) : _vm._e()], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }